<template>
  <div v-loading="loading">
    <div class="title">出题任务</div>
    <div class="search-box">
      <div>
        <el-select
          class="w-200 mr-12"
          v-model="search.stack_id"
          size="medium"
          filterable
          remote
          reserve-keyword
          clearable
          placeholder="关联技能点"
          prefix-icon="el-icon-search"
          :remote-method="remoteStack"
          :loading="selectLoading"
        >
          <el-option
            v-for="point in skill_points"
            :key="point.id"
            :label="point.name"
            :value="point.id"
          ></el-option>
        </el-select>
        <el-input
          class="w-150 mb-12 mr-12"
          placeholder="关联考点"
          prefix-icon="el-icon-search"
          v-model.trim="search.exam_tag"
          size="medium"
          clearable
        >
        </el-input>
        <el-button type="primary" size="medium" plain @click="handleSearch"
          >查询</el-button
        >
        <el-button size="medium" @click="clearSearch">重置</el-button>
      </div>
      <div>
        <el-link
          style="height: 100%"
          size="small"
          icon="el-icon-question"
          type="primary"
          @click="openWay"
          :underline="false"
          >如何出题 ？</el-link
        >
      </div>
    </div>
    <el-table :data="list" :stripe="true">
      <el-table-column width="110" label="任务优先级">
        <template slot="header">
          <div>
            任务优先级<el-tooltip>
              <div slot="content">
                代表任务的紧急程度P1（非常紧急）～P10（不紧急）
              </div>
              <i class="el-icon-question" style="margin-left: 5px"></i>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <div>P{{ scope.row.priority }}</div>
        </template>
      </el-table-column>
      <el-table-column width="135" label="关联技能点" show-overflow-tooltip>
        <template v-slot="scope">
          {{ scope.row.stacks.length ? getName(scope.row.stacks) : "-" }}
        </template>
      </el-table-column>
      <el-table-column min-width="135" label="关联考点" show-overflow-tooltip>
        <template v-slot="scope">
          {{ getName(scope.row.exam_tags) }}
        </template>
      </el-table-column>
      <el-table-column width="110" label="指定编程语言" show-overflow-tooltip>
        <template v-slot="scope">
          {{ getName(scope.row.program_languages) }}
        </template>
      </el-table-column>

      <el-table-column min-width="135" label="题目需求说明">
        <template slot-scope="scope">
          <div
            class="hidden-redundant"
            @click="openDialog(scope.row.description)"
          >
            {{ scope.row.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="110"
        label="题目需求总量"
        prop="required_total_number"
      ></el-table-column>
      <el-table-column width="140" label="待审核 / 已通过">
        <template slot-scope="scope">
          <div>
            {{ scope.row.question_verifying_count }} /
            {{ scope.row.question_passed_count }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="100">
        <template slot="header">
          <div @click="toggleShowContent" class="toggle-show">
            <span>题目单价</span>
            <i class="el-icon-view toggle-show-icon"></i>
          </div>
        </template>
        <template slot-scope="scope">
          <show-hide-content
            :value="scope.row.unit_price"
            :show.sync="isShow"
          ></show-hide-content>
        </template>
      </el-table-column>
      <el-table-column width="150" label="任务截止时间">
        <template slot-scope="scope">
          <div v-if="scope.row.end_date">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.end_date }}</span>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        v-if="
          authPermissions.includes(
            'coding.api.jiker_fuwu_admin.questions.store'
          )
        "
        width="70"
        label="操作"
      >
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="assignTopic(scope.row.id)"
            >去出题</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="goPage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>

    <el-dialog
      class="skill-task-dialog"
      :visible.sync="dialogVisible"
      width="1000px"
      :show-close="false"
      center
    >
      <markdown-it :md="dialogDescription"></markdown-it>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import codeService from "@/global/service/code";

import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
import ShowHideContent from "@/components/ShowHideContent";

export default {
  components: {
    MarkdownIt,
    ShowHideContent
  },
  data() {
    return {
      loading: true,
      isShow: false,
      selectLoading: false,
      search: {
        stack_id: null,
        exam_tag: null
      },
      skill_points: [],
      list: [],
      examList: [],
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      dialogVisible: false,
      dialogDescription: ""
    };
  },
  computed: {
    ...mapState(["authPermissions"]),
    getName() {
      return arr => {
        return arr.map(item => item.name).join("、");
      };
    }
  },
  created() {
    this.getData();
  },
  watch: {
    $route() {
      this.getData();
    }
  },
  methods: {
    getData() {
      const page = Number(this.$route.query.page) || 1;
      const params = {
        page,
        page_size: this.pagination.pageSize
      };
      Object.keys(this.search).forEach(key => {
        if (this.search[key]) {
          params[key] = this.search[key];
        }
      });
      this.loading = true;
      codeService
        .getQuestionTask(params)
        .then(res => {
          this.list = res.list;
          this.pagination.currentPage = Number(res.pagination.current_page);
          this.pagination.total = Number(res.pagination.total);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openWay() {
      window.open("https://jiker.feishu.cn/docx/doxcnQ8KaWVY2aApnIl2wsuA19c");
    },
    assignTopic(id) {
      this.$router.push({
        name: "ProgramQuestionCreate",
        params: { id }
      });
    },
    goPage(val) {
      this.$router.push({
        name: "programTaskSelf",
        query: { page: val }
      });
    },
    toggleShowContent() {
      this.isShow = !this.isShow;
    },
    handleSearch() {
      if (JSON.stringify(this.$route.query) !== "{}") {
        this.$router.push({
          name: "programTaskSelf",
          query: {}
        });
      }
      this.getData();
    },
    clearSearch() {
      this.search = {
        stack_id: null,
        exam_tag: null
      };
      if (JSON.stringify(this.$route.query) !== "{}") {
        this.$router.push({
          name: "programTaskSelf",
          query: {}
        });
      }
      this.getData();
    },
    remoteStack(query) {
      if (query !== "") {
        this.selectLoading = true;
        codeService
          .kcellSkills({ name: query })
          .then(res => {
            this.skill_points = res;
          })
          .finally(() => {
            this.selectLoading = false;
          });
      } else {
        this.skill_points = [];
      }
    },
    remoteExam(query) {
      if (query !== "") {
        this.selectLoading = true;
        codeService
          .getExamTags({ name: query })
          .then(res => {
            this.skill_points = res;
          })
          .finally(() => {
            this.selectLoading = false;
          });
      } else {
        this.skill_points = [];
      }
    },
    openDialog(description) {
      this.dialogVisible = true;
      this.dialogDescription = description;
    }
  }
};
</script>

<style lang="less">
.skill-task-dialog {
  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
}
</style>
<style lang="less" scoped>
.search-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
.hidden-redundant {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  &:hover {
    color: #409eff;
  }
}
.toggle-show {
  cursor: pointer;
  .toggle-show-icon {
    margin-left: 4px;
  }
  &:hover {
    color: #409eff;
  }
}
</style>
